var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeats = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0491 12.4969C13.0491 14.3902 11.2759 14.3464 11.0884 14.3464H7.47723V10.6996H11.0884C12.9884 10.6996 13.0491 12.1237 13.0491 12.4969ZM10.8103 9.23214C10.8402 9.23214 12.5263 9.27679 12.5263 7.61116C12.5263 6.9183 12.3696 6.00982 10.8103 6.00982H7.47723V9.23214H10.8103ZM20 3.33348V16.6665C19.9974 17.5498 19.6454 18.3962 19.0208 19.0208C18.3962 19.6454 17.5498 19.9974 16.6665 20H3.33348C2.45018 19.9974 1.6038 19.6454 0.979217 19.0208C0.354628 18.3962 0.00259102 17.5498 0 16.6665L0 3.33348C0.00259102 2.45018 0.354628 1.60381 0.979217 0.979217C1.6038 0.354628 2.45018 0.00259102 3.33348 0H16.6665C17.5498 0.00259102 18.3962 0.354628 19.0208 0.979217C19.6454 1.60381 19.9974 2.45018 20 3.33348ZM15.0915 12.7616C15.0915 11.7987 14.7946 10.1594 12.9018 9.75491V9.72232C13.9246 9.28571 14.5688 8.46116 14.5688 7.23839C14.5688 6.92589 14.658 4.34643 11.1045 4.34643H5.43482V16.0129C11.1594 16.0129 11.679 16.0879 12.7384 15.758C13.3728 15.5607 15.0915 14.9554 15.0915 12.7616Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beats.28a3b489fa070302f54df5cc17327ab6.svg";